import React, { useRef, useState } from 'react';
import "./Search.css";
import Select from 'react-select';
import calendarIcon from '../../../assets/calendar.svg'
import loop from '../../../assets/Vector.svg'
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import SelectCity from './SelectCity/SelectCity';
import DatePicker from "react-multi-date-picker";
import 'react-datepicker/dist/react-datepicker.css';
import { format, set } from 'date-fns';
import { parse } from 'date-fns';
import { AiOutlineClose } from 'react-icons/ai';
import { URL_Back } from '../../Variables';
import { useTranslation } from 'react-i18next';
import moment from 'moment';


const Search = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const API_KEY = 'a2b18f9cfb72eb93f3ce6b1c30372b59';
  const API_URL = `${URL_Back}/lot/maxprice`;
  const [lotData, setLotData] = useState([]);
 
  const [date, setDate] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const location = useLocation();
  const [city, setCity] = useState("")
  const [isSliderVisible, setIsSliderVisible] = useState(false);
  const [keyWord, setKeyWord] = useState("")
  const [voyageur, setVoyageur] = useState("")
  const [active, setActive] = useState(true)
  const [travelers, setTravelers] = useState(1);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false); 
  const datePickerRef = useRef(null); 

  const handleSliderOpen = () => {
    setIsSliderVisible(true);
  };
  const navigate = useNavigate()
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#fff',
      border: '1px solid #ccc',
      cursor: 'pointer',
      margin: '0',
      padding: '0px',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      cursor: 'pointer',
    }),
    noOptionsMessage: (base) => ({
      ...base,
      display: 'none'
    }),
  };


  const handleChangeSortBy = (e) => {
    setSortBy(e.target.value);
  };
  const handleKeyWordChange = (e) => {
    const newKeyword = e.target.value;
    setKeyWord(newKeyword);

    if (newKeyword.trim() === '') {
      setActive(true);
    } else {
      setActive(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = {
          'apiKey': API_KEY,
        };

        const response = await fetch(API_URL, { method: 'GET', mode: 'cors', headers });
        if (!response.ok) {
          throw new Error('Response not OK');
        }

        const data = await response.json();
        setLotData(data.data.lot);



      } catch (error) {
        console.error('Erreur lors de la récupération des données :', error);
      }
    };

    fetchData();
  }, [API_URL, API_KEY]);

  const [max, setMax] = useState(2000)
  const [priceRange, setPriceRange] = useState([0, max]);

  useEffect(() => {
    const loyerHc = lotData && lotData.loyer_hc ? parseInt(lotData.loyer_hc, 10) : 0;
    const charges = lotData && lotData.charges ? parseInt(lotData.charges, 10) : 0;
    if (loyerHc + charges > max) {
      setMax(loyerHc + charges);

    }

  }, [lotData, max]);

  useEffect(() => {
    setPriceRange([0, max]);
  }, [max]);
  
  const handleInputClick = () => {
    if (isCalendarOpen) {
      datePickerRef.current.closeCalendar(); 
    } else {
      datePickerRef.current.openCalendar(); 
    }
    setIsCalendarOpen(!isCalendarOpen);
  };




  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const cityParam = searchParams.get('city');
    const dateParam = searchParams.get('start_date');
    const dateParam2 = searchParams.get('end_date');
    const voyageurParam = searchParams.get('nbr_pers');
    const priceMinParam = searchParams.get('priceMin');
    const priceMaxParam = searchParams.get('priceMax');
    const sortByParam = searchParams.get('sortBy');
    const keyWordParam = searchParams.get('keyword');
    if (keyWordParam) {
      setKeyWord(keyWordParam);
      setActive(false);
    }
    if (cityParam) {
      setCity(cityParam);
    }
    if (voyageurParam) {
      setTravelers(voyageurParam);
    }
    console.log(dateParam)
    if (dateParam && dateParam2) {
      const startDateFormatted = moment(dateParam);
      const endDateFormatted = moment(dateParam2);
      if (startDateFormatted.isValid() && endDateFormatted.isValid()) {
        setDate([startDateFormatted, endDateFormatted]);
      }
    }
  
    setSortBy(sortByParam || "");


    if (priceMinParam && priceMaxParam) {
      setPriceRange([parseInt(priceMinParam), parseInt(priceMaxParam)]);
    }
    if (priceMaxParam && priceMinParam) {
      const parsedMax = parseInt(priceMaxParam);
      const parcedMin = parseInt(priceMinParam)
      setPriceRange([parcedMin, parsedMax]);
    }
  }, [location.search]);
  const handlePriceRangeChange = (newValue) => {
    setPriceRange(newValue);
  };

  const formatPriceRangeLabel = (priceRange) => {
    return `${priceRange[0]}€ - ${priceRange[1]}€`;
  };

  const selectValue = { label: formatPriceRangeLabel(priceRange), value: `${priceRange[0]}-${priceRange[1]}` };
  const handleSubmit = (e) => {
    e.preventDefault();
    const searchParams = new URLSearchParams();
    searchParams.append('city', city);
    const [arrivalDate,departureDate] = date;
    const formattedDepartureDate = departureDate ? departureDate.format('YYYY-MM-DD') : '';
    const formattedArrivalDate = arrivalDate ? arrivalDate.format('YYYY-MM-DD') : '';
   
    if (formattedDepartureDate) {
      searchParams.append('end_date', formattedDepartureDate);
    }
    if (formattedArrivalDate) {
      searchParams.append('start_date', formattedArrivalDate);
    }
    searchParams.append('sortBy', sortBy);
    searchParams.append('priceMin', priceRange[0]);
    searchParams.append('priceMax', priceRange[1]);
    searchParams.append('nbr_pers', travelers)



    const url = `/search-cities?${searchParams.toString()}`;
    navigate(url);
    window.location.reload();
  };
  const handleSubmit2 = (e) => {
    e.preventDefault();
    const searchParams = new URLSearchParams();
    if (keyWord) {
      searchParams.append('keyword', keyWord)
    }

    const url = `/search-cities?${searchParams.toString()}`;
    navigate(url);
    window.location.reload();

  }


  const handleMoveInDateChange = (date) => {
    setDate(date || []);
    localStorage.setItem('arrivalDate', date[0]);
    localStorage.setItem('departureDate', date[1]);
  };
  console.log("Date:", date);
  
  
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return (
    <div className='Search-container'>
      <div className="container">
        <h2>{t('search.title')}</h2>
        <div className='Form-cities'>
          <form className='' onSubmit={handleSubmit}>
            <div className={`row form-top gap-lg-2 gap-0 align-items-end jusify-content-end ${!active ? 'disabled' : ''}`}>
              <div className='Form-city col-lg-3 col-md-6 col-sm-12 '>
                <label htmlFor="countries">{t('search.city')}</label>
                <div className='input-select'>
                  <SelectCity
                    id='countries'
                    text='Where will you go?'
                    onChange={(selectedValue) => { setCity(selectedValue.value); }}
                    city={city}
                    alert={true}
                  />

                  <input type="hidden" name="city" value={city} id="hidden-city" />


                </div>
              </div>
              <div className='Form-city col-lg-3 col-md-6 col-sm-12 '>
                <div className=''>
                  <label htmlFor="cars">{t('search.date')}</label>
                  <DatePicker
                    ref={datePickerRef} 
                    placeholder={t('intro.depart')}
                    numberOfMonths={2}
                    range
                    calendarPosition="bottom-center"
                    selected={date}
                    value={date}
                    name="date"
                    dateFormat="dd/MM/yyyy"
                    onChange={handleMoveInDateChange}
                    render={
                      <div className="input-datepicker" >
                        <input
                          type="text"
                          className='Select-country-container'
                          value={date.length === 2 ? `${date[0].format('DD/MM/YYYY')} - ${date[1].format('DD/MM/YYYY')}` : ''}
                          readOnly
                          placeholder={t('search.depart')}
                          onClick={handleInputClick} 
                        />
                        <span className="calendar-icon">
                          <img src={calendarIcon} alt="Calendar" />
                        </span>
                      </div>
                    }
                    minDate={tomorrow}
                  />
                </div>
              </div>

              <div className='Form-city col-lg-3 col-md-6 col-sm-12 '>
                <label htmlFor="priceRange">{t('search.price')}</label>

                <div className='select-wrapper'>
                  <div className='select-container'>
                    <Select
                      id='priceRange'
                      styles={customStyles}
                      onMenuOpen={handleSliderOpen}
                      options={[]}
                      onChange={() => { }}
                      value={selectValue}
                      isSearchable={false}
                      placeholder="Select a price range"
                      closeMenuOnSelect={false}
                      isDisabled={isSliderVisible} 
                    />
                  </div>

                  {isSliderVisible && (
                    <div className='slider-container container'>
                      <div className='d-flex flex-row-reverse flex-wrap align-content-center justify-content-between'>
                        <AiOutlineClose className='close-icon' onClick={() => setIsSliderVisible(false)} />
                        <h5>{t('search.monthprice')}</h5>
                      </div>
                      <div className='price'>
                        <Slider
                          min={0}
                          max={max}
                          value={priceRange}
                          onChange={handlePriceRangeChange}
                          range
                        />
                      </div>
                      <div>
                        <span className='price-range-input'>
                          <label>{priceRange[0]}€</label>
                          <label>{priceRange[1]}€</label>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='Form-city col-lg-3 col-md-6 col-sm-12'>
                <label htmlFor="price">{t('search.sort')}</label>
                <div className='input-select'>
                  <select name="price" id="price" className='form-control' onChange={handleChangeSortBy} value={sortBy} disabled={!active}>
                    <option value="">{t('search.sorted')}</option>
                    <option value="desc">{t('search.desc')}</option>
                    <option value="asc">{t('search.asc')}</option>
                    <option value="av">{t('search.avail')}</option>
                  </select>
                </div>
              </div>

              <div className='Form-city col-lg-3 col-md-6 col-sm-12'>
                <label htmlFor="voyageurs">{t('search.travelers')}</label>
                <input
                  type="number"
                  className='Select-country-container input-select '
                  value={travelers}
                  min={1}
                  onChange={(e) => setTravelers(e.target.value)}
                  placeholder="Voyageurs"
                />

              </div>

              <div className="form-search-btn col-lg-2 col-md-6 col-sm-12 p-lg-0 d-flex flex-row-reverse">
                <button className='Search-cribs-btn' type='submit'>{t('search.result')}</button>
              </div>
            </div>
            <div className=' mt-4'>
              <div className='d-md-flex flex-row align-items-center justify-content-start gap-2'>
                <label>{t('search.word')}</label>
                <div className='input-keyword'>
                  <input
                    id='keyword'
                    type="text"
                    name="KeyWord"
                    value={keyWord}
                    className='form-control'
                    placeholder={t('search.word')}
                    onChange={handleKeyWordChange}
                  />
                  <span className='vertical-line'></span>
                  <span className="calendar-icon" onClick={handleSubmit2}>
                    <img src={loop} alt="loop" className='loop' />

                  </span>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div >
    </div >
  );
}

export default Search;